<template>
  <div>
    <Title :pages="[{ icon: 'circle', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <v-btn v-if="create_access" color="primary" class="mb-5" @click="updateDialog(true)"> Crear {{ modal_title }} </v-btn>

      <Modal
        v-if="create_access || update_access"
        :modal_title="modal_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :parent="parent"
        :service="service"
        :revertOf="revertOfId"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
        @confirmRevert="confirmRevert"
        :item="mainItem"
        @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        "
      />

      <!-- Filtros -->
      <v-card class="mb-3">
        <div class="row ma-0 pa-3">
          <div class="col-md-3">
            <v-menu
              ref="desde_selected"
              v-model="desde_selected_open"
              :close-on-content-click="false"
              :return-value.sync="desde_selected"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="desde_selected" label="Desde" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
              </template>
              <v-date-picker v-model="desde_selected" type="date" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="desde_selected_open = false">Cancelar</v-btn>
                <v-btn text color="primary" @click="$refs.desde_selected.save(desde_selected)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </div>

          <div class="col-md-3">
            <v-menu
              ref="hasta_selected"
              v-model="hasta_selected_open"
              :close-on-content-click="false"
              :return-value.sync="hasta_selected"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="hasta_selected" label="Hasta" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
              </template>
              <v-date-picker v-model="hasta_selected" type="date" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="hasta_selected_open = false">Cancelar</v-btn>
                <v-btn text color="primary" @click="$refs.hasta_selected.save(hasta_selected)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </div>

          <div class="col-md-3">
            <v-combobox v-model="clase_selected" item-text="name" item-value="id" :items="clases_comprobante" label="Tipo de comprobante" clearable class="pt-0 mt-0"></v-combobox>
          </div>

          <div class="col-md-3">
            <v-text-field v-model="nro_mov_selected" label="Nro. Movimiento" class="pt-0 mt-0"></v-text-field>
          </div>

          <div class="col-md-3">
            <v-text-field v-model="reference_selected" label="Referencia" class="pt-0 mt-0"></v-text-field>
          </div>

          <div class="col-md-3">
            <v-combobox v-model="money_account_selected" item-text="name" item-value="id" :items="money_accounts" label="Cuenta" clearable class="pt-0 mt-0"></v-combobox>
          </div>

          <div class="col-md-3">
            <v-combobox v-model="concepto_selected" item-text="name" item-value="id" :items="conceptos" label="Concepto" multiple small-chips clearable class="pt-0 mt-0"></v-combobox>
          </div>

          <div class="col-md-3 d-flex justify-end">
            <v-btn color="blue-grey" dark :loading="dialog_export" @click="exportFile()" class="mr-2">Exportar <font-awesome-icon icon="download" class="ml-2" /></v-btn>
            <v-btn color="info" @click="filter">Buscar</v-btn>
          </div>
        </div>
      </v-card>

      <!-- Tabla -->
      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :loading="loading"
          loading-text="Cargando..."
          :options="{ itemsPerPage: 15 }"
          @pagination="updatePagination"
          :footer-props="{ itemsPerPageOptions: [5, 10, 15, 50, -1] }"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.nro_mov }}</td>
              <td>{{ props.item.date_esp }}</td>
              <td>{{ props.item.clase_comprobante ? props.item.clase_comprobante.name : "-" }}</td>
              <td>{{ props.item.concept }}</td>
              <td>{{ props.item.reference }}</td>
              <td class="text-right">{{ formatUtils.formatPrice(props.item.amount) }}</td>
              <td class="text-center px-0" style="min-width: 130px">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-2" @click="viewItem(props.item)">remove_red_eye</v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>
                <v-tooltip v-if="update_access && props.item.is_manual" bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="green" class="mr-2" @click="editItem(props.item)">edit</v-icon>
                  </template>
                  <span>Editar concepto, referencia y motivos</span>
                </v-tooltip>
                <v-tooltip v-if="!props.item.reverted && props.item.is_manual" bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="orange" @click="startRevert(props.item)">replay</v-icon>
                  </template>
                  <span>Revertir</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Búsqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <DialogLoading :dialog="dialog_loading" text="Cargando..." />

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { tesoreriaMovementService } from "@/libs/ws/tesoreriaMovementService";
import { generalService } from "@/libs/ws/generalService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import DialogLoading from "@/components/DialogLoading.vue";
import Modal from "./Modal.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import { formatUtils } from "@/libs/utils/formatUtils";

export default {
  components: { Title, Modal, DialogDelete, DialogLoading },
  mixins: [GenericMixin, RolMixin, ExportMixin],
  data() {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().slice(0, 10);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().slice(0, 10);

    return {
      formatUtils: formatUtils,
      parent: this,
      service: tesoreriaMovementService,
      page_title: "Movimientos de Tesorería",
      modal_title: "Movimiento de Tesorería",
      mainItem: {
        id: "",
        date: today.toISOString().slice(0, 10),
        clase_comprobante: null,
        emitter: null,
        concept: null,
        reference: null,
        details: [
          { money_account: null, sub_cost_center: null, amount_debe: null, amount_haber: null, description: null },
          { money_account: null, sub_cost_center: null, amount_debe: null, amount_haber: null, description: null },
        ],
      },
      detailTemplate: {
        money_account: null,
        sub_cost_center: null,
        amount_debe: null,
        amount_haber: null,
        description: null,
      },
      defaultItem: null,
      headers: [
        { text: "Numero", align: "left", sortable: true, value: "nro_mov" },
        { text: "Fecha", align: "left", sortable: true, value: "date" },
        { text: "Comprobante", align: "left", sortable: true, value: "clase_comprobante.name" },
        { text: "Concepto", align: "left", sortable: true, value: "concept" },
        { text: "Referencia", align: "left", sortable: true, value: "reference" },
        { text: "Importe", align: "right", sortable: true, value: "amount" },
        { text: "Acción", align: "center", value: "" },
      ],
      list: [],
      dialog_delete: false,
      clases_comprobante: [],
      money_accounts: [],
      conceptos: [],
      desde_selected_open: false,
      hasta_selected_open: false,
      desde_selected: firstDay,
      hasta_selected: lastDay,
      clase_selected: null,
      reference_selected: null,
      nro_mov_selected: null,
      money_account_selected: null,
      concepto_selected: [],
      revertOfId: null,
      dialog_loading: false,
    };
  },
  mounted() {
    this.loadComboData();
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.filter();
  },
  methods: {
    deleteItemConfirm() {
      this.delete(this.service);
      this.dialog_delete = false;
      this.filter();
    },
    exportFile() {
      const param = this.getFilterParams();
      param.raw = false; //El export necesita las entidades completas
      this.exportExcel(Constant.SECTION_TESORERIA_MOVEMENTS + "/export_list", param, "Movimientos-Tesoreria.xlsx");
    },
    getFilterParams() {
      return {
        raw: true, //El listado se resuelve por SQL: filas planas, sin objetos de Doctrine
        date_from: this.desde_selected,
        date_to: this.hasta_selected,
        clase_comprobante: this.clase_selected ? this.clase_selected.id : null,
        nro_mov: this.nro_mov_selected || null,
        reference: this.reference_selected,
        money_account: this.money_account_selected ? this.money_account_selected.id : null,
        concepto: this.concepto_selected.length ? this.concepto_selected.map((c) => c.id) : null,
      };
    },
    filter() {
      this.loadList(this.service);
    },
    //El listado trae filas planas: para los modales se pide el objeto completo por id
    async requestMovement(id) {
      try {
        const response = await this.service.get({ id: id });
        if (response.status === true) return response.result;
        this.$toast.error(response.msg, "Error");
      } catch (e) {
        console.log("tesoreriaMovementService.get error");
        console.log(e);
        this.$toast.error("Error al obtener el movimiento", "Error");
      }
      return null;
    },
    async fetchMovement(id) {
      this.dialog_loading = true;
      const movement = await this.requestMovement(id);
      this.dialog_loading = false;
      return movement;
    },
    normalizeDetails(item) {
      if (item.details) {
        item.details = item.details.map((d) => ({
          ...d,
          amount_debe: d.movement_type === "D" ? d.amount : null,
          amount_haber: d.movement_type === "H" ? d.amount : null,
        }));
      }
      return item;
    },
    //Sobrescriben GenericMixin: la fila del listado no alcanza para el modal
    async editItem(item) {
      this.errors && this.errors.clear();

      const movement = await this.fetchMovement(item.id);
      if (movement == null) return;

      this.editedIndex = this.list.indexOf(item);
      this.mainItem = this.normalizeDetails(movement);
      this.dialog = true;
    },
    async viewItem(item) {
      const movement = await this.fetchMovement(item.id);
      if (movement == null) return;

      this.viewdIndex = this.list.indexOf(item);
      this.mainItem = this.normalizeDetails(movement);
      this.dialog = true;
    },
    loadComboData() {
      generalService.setSection(Constant.SECTION_TESORERIA_CLASE_COMPROBANTE);
      generalService
        .filter()
        .then((r) => {
          this.clases_comprobante = r.result;
        })
        .catch(() => {});

      generalService.setSection(Constant.SECTION_MONEY_ACCOUNTS);
      generalService
        .filter()
        .then((r) => {
          this.money_accounts = r.result;
        })
        .catch(() => {});

      //Mismo combo que usa el Modal para imputar el concepto de cada detalle
      generalService.setSection(Constant.SECTION_CONCEPTOS);
      generalService
        .filter()
        .then((r) => {
          this.conceptos = r.result;
        })
        .catch(() => {});
    },
    updateDialog(val) {
      if (!val) {
        this.revertOfId = null;
        this.close();
      }
      this.dialog = val;
    },
    //La reversion se arma invirtiendo los detalles, que no viajan en la fila del listado
    async startRevert(item) {
      const movement = await this.fetchMovement(item.id);
      if (movement == null) return;

      const invertedDetails = (movement.details || []).map((d) => ({
        ...d,
        id: null,
        movement_type: d.movement_type === "D" ? "H" : "D",
        amount_debe: d.movement_type === "D" ? null : d.amount,
        amount_haber: d.movement_type === "D" ? d.amount : null,
      }));
      this.mainItem = {
        id: "",
        //Se precarga la fecha del movimiento original; el usuario puede cambiarla en el modal.
        date: movement.date,
        clase_comprobante: null,
        emitter: movement.emitter || null,
        concept: "Reversión de Mov. #" + movement.nro_mov + (movement.concept ? " - " + movement.concept : ""),
        reference: "Reversión de movimiento ID: " + movement.id,
        details: invertedDetails,
      };
      this.revertOfId = movement.id;
      this.viewdIndex = this.list.indexOf(item);
      this.dialog = true;
    },
    confirmRevert(id) {
      this.loading = true;
      //La fecha del modal es la de impacto de la reversion, no necesariamente hoy.
      tesoreriaMovementService
        .revert(id, { date: this.mainItem.date })
        .then((r) => {
          if (r.status) {
            this.$toast.success("Reversión creada correctamente.", "OK");
            this.updateDialog(false);
            this.filter();
          } else {
            this.$toast.error(r.msg || r.message, "Error");
          }
        })
        .catch(() => {
          this.$toast.error("Error al revertir el movimiento.", "Error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
